import React from "react";
import { withI18n } from "react-i18next";
// @ts-ignore
import { moment } from "cwb-react";
import { ISessionTemplateInfoSheet } from "../../../interfaces/ISessionTemplateInfoSheet";

const ProjectDetailsSection = (props: {
  t: any;
  sessionTemplateInfoSheet: ISessionTemplateInfoSheet;
}) => {
  const { t, sessionTemplateInfoSheet } = props
  return (
    <section>
      <form>
        <div className="form-group row">
          <label className="col-4 col-form-label">{t("Project")}</label>
          <div className="col-8">
            <input
              type="text"
              className="form-control-plaintext"
              value={
                (sessionTemplateInfoSheet &&
                  sessionTemplateInfoSheet.projectName) ||
                ""
              }
              readOnly={true}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-4 col-form-label">
            {t("Casting Director")}
          </label>
          <div className="col-8">
            <input
              type="text"
              className="form-control-plaintext"
              value={
                (sessionTemplateInfoSheet &&
                  sessionTemplateInfoSheet.directorName) ||
                ""
              }
              readOnly={true}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-4 col-form-label">{t("Audition")}</label>
          <div className="col-8">
            <input
              type="text"
              className="form-control-plaintext"
              value={
                sessionTemplateInfoSheet
                  ? moment
                      .moment(sessionTemplateInfoSheet.auditionDate)
                      .format("LL")
                  : ""
              }
              readOnly={true}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-4 col-form-label">{t("Role")}</label>
          <div className="col-8">
            <input
              type="text"
              className="form-control-plaintext"
              value={
                (sessionTemplateInfoSheet &&
                  sessionTemplateInfoSheet.roleName) ||
                ""
              }
              readOnly={true}
            />
          </div>
        </div>
        {(sessionTemplateInfoSheet && sessionTemplateInfoSheet.spotName) !== null && <div className="form-group row">
          <label className="col-4 col-form-label">{t("Spot")}</label>
          <div className="col-8">
            <input
              type="text"
              className="form-control-plaintext"
              value={
                (sessionTemplateInfoSheet &&
                  sessionTemplateInfoSheet.spotName) ||
                ""
              }
              readOnly={true}
            />
          </div> 
        </div>}
        <div className="form-group row">
          <label className="col-4 col-form-label">{t("Location")}</label>
          <div className="col-8">
            <input
              type="text"
              className="form-control-plaintext"
              value={
                (sessionTemplateInfoSheet &&
                  sessionTemplateInfoSheet.location) ||
                ""
              }
              readOnly={true}
            />
          </div>
        </div>
      </form>
    </section>
  );
};

export default withI18n()(ProjectDetailsSection);
